module.exports = __webpack_public_path__ + "imgs/amenities.9cfb5b7b59acb163f5417b6b34246a33.svg";